import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'psf-promote-or-share',
		path: '/p/:slug/psf/promote_or_share',
		component: loadable(async () => import(/* webpackChunkName: "pages/psf_promote_or_share" */ './index'), {
			exportName: 'PsfPromoteOrShare',
			fallback: Loading,
		}),
		frame: false,
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: false,
			// FIXME: temporary solution to force external navigation (resulting in session update)
			// when navigating to and from this page, to handle sign resulting in an identified state in non-GDPR countries
			isolated: true,
		},
	},
];
